<template>

<div class="relative w-full">
                    <div class="relative">
                        <div class="absolute inset-0">

                            <div class="block absolute inset-0 w-full h-full rounded-t-lg bg-black/30 md:hidden">

                            </div>

                            <nuxt-img src="/assets/images/modal-hero-mind.png" width="1536" height="778"
                                alt="Mindflow Upsell Background"
                                class="hidden object-cover w-full h-full rounded-lg md:block" loading="eager"
                                sizes="xs:330px sm:440px md:760px lg:1024px xl:1200px 2xl:1920px"
                                 fetchpriority="high" />

                            <nuxt-img src="/assets/images/mindlfow-new-mobile-modal1.jpg" sizes="xs:330px sm:440px md:760px lg:1024px xl:1200px 2xl:1920px" width="590" height="792"
                                alt="Mindflow Upsell Background" class="object-cover w-full h-full rounded-lg md:hidden"
                                loading="eager" preload fetchpriority="high" />

                        </div>

                        <div class="relative z-10 p-6 px-4 xl:px-24 md:pb-40 md:pt-32 lg:pb-52 lg:pt-40">
                            <div class="sm-max:mt-5">
                                <div
                                    class="flex gap-x-1 justify-center text-xl text-white md:mb-1 md:text-2xl xl:text-3xl md:justify-start">
                                    <span class="">
                                        🔥

                                    </span>

                                    <span class="uppercase font-ww-bold">
                                        Wait—Before You Go!
                                    </span>
                                </div>
                                <svg class="mx-auto w-64 md:w-80 xl:w-fit md:mx-0" width="391" height="22"
                                    viewBox="0 0 400 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_d_40_1151)">
                                        <path
                                            d="M4 2.26498C4.05615 4.59763 4.11229 6.93029 4.16844 9.26295C11.0822 9.03819 17.9959 8.81342 24.9096 8.58866C61.9987 7.38292 99.0877 6.17717 136.177 4.97142L134.635 0.717688C131.176 3.51439 127.716 6.31109 124.257 9.10779L118.881 13.3438L125.741 13.1605C208.633 9.90693 291.525 6.65337 374.417 3.39982C381.329 3.12851 388.241 2.85721 395.153 2.58591C388.238 2.7406 381.322 2.89529 374.406 3.04998C291.471 4.90509 208.536 6.76021 125.601 8.61532L127.086 12.668C130.592 9.93005 134.098 7.19209 137.604 4.45413L143.162 1.03086e-07L136.062 0.200397C98.9579 0.780461 61.8537 1.36052 24.7496 1.94059C17.8331 2.04872 10.9165 2.15685 4 2.26498Z"
                                            fill="#D2F06F" />
                                    </g>
                                    <defs>
                                        <filter id="filter0_d_40_1151" x="0" y="0" width="399.153" height="21.3438"
                                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset dy="4" />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix"
                                                result="effect1_dropShadow_40_1151" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_40_1151"
                                                result="shape" />
                                        </filter>
                                    </defs>
                                </svg>

                            </div>

                            <div class="mt-4">
                                <div class="max-w-3xl">
                                    <span
                                        class="pr-2 text-2xl text-white md:text-4xl xl:text-5xl font-ww-medium">Lock-In</span>

                                    <span
                                        class="xl:text-[80px] md:text-6xl text-4xl text-lifeboost-green-400 font-ww-bold leading-none"
                                        style="text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);">6 More Bags</span>
                                    <br>
                                    <div class="max-w-2xl text-2xl text-white md:text-4xl xl:text-5xl font-ww-medium sm-max:leading-6"
                                        style="text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);">of MindFlow at the Insider
                                        Rate of ONLY $21.25 per bag</div>
                                </div>
                                <div class="mt-2 text-lg italic text-white md:text-2xl xl:text-3xl font-ww-regular">
                                    (That’s 40% OFF Retail)
                                </div>

                                <div class="flex justify-center mt-6 md:justify-start md:mt-12">
                                    <button
                                        @click="handleAccept"
                                        class="flex gap-x-2 justify-center items-center px-8 py-3 text-lg font-bold text-white rounded-full md:gap-x-4 md-max:text-base md:px-12 md:py-4 btn-red md:text-2xl font-ww-medium"
                                        style="background-color:#F1594B;">YES, UPGRADE MY ORDER
                                        <span
                                            data-v-inspector="components/section/content/ComparisonPrice.vue:96:21"><svg
                                                width="21" height="15" viewBox="0 0 21 15" fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                data-v-inspector="components/section/content/ComparisonPrice.vue:97:25">
                                                <path
                                                    d="M12.8593 0.338767C12.7655 0.43173 12.6911 0.542331 12.6404 0.66419C12.5896 0.78605 12.5635 0.916755 12.5635 1.04877C12.5635 1.18078 12.5896 1.31148 12.6404 1.43334C12.6911 1.5552 12.7655 1.6658 12.8593 1.75877L17.4593 6.35877L1.05859 6.17123C0.793377 6.17123 0.539023 6.27659 0.351487 6.46412C0.163951 6.65166 0.0585938 6.90601 0.0585938 7.17123C0.0585938 7.43645 0.163951 7.6908 0.351487 7.87834C0.539023 8.06587 0.793377 8.17123 1.05859 8.17123L17.4393 8.35877L12.8593 12.9288C12.673 13.1161 12.5685 13.3696 12.5685 13.6338C12.5685 13.898 12.673 14.1514 12.8593 14.3388C13.0466 14.525 13.3001 14.6296 13.5643 14.6296C13.8284 14.6296 14.0819 14.525 14.2693 14.3388L20.6293 7.97877C20.7149 7.89664 20.783 7.79805 20.8295 7.68892C20.876 7.5798 20.9 7.4624 20.9 7.34377C20.9 7.22514 20.876 7.10773 20.8295 6.99861C20.783 6.88949 20.7149 6.7909 20.6293 6.70877L14.2793 0.338767C14.1863 0.245039 14.0757 0.170645 13.9538 0.119876C13.832 0.0691072 13.7013 0.0429688 13.5693 0.0429688C13.4372 0.0429688 13.3065 0.0691072 13.1847 0.119876C13.0628 0.170645 12.9522 0.245039 12.8593 0.338767Z"
                                                    fill="white"
                                                    data-v-inspector="components/section/content/ComparisonPrice.vue:98:29">
                                                </path>
                                            </svg></span></button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

</template>

<script setup>
// Inject the handleAccept function from parent upsell modal
const handleAccept = inject('handleAccept', () => {
    console.warn('handleAccept not provided by parent')
})
</script>